document.addEventListener('DOMContentLoaded', function () {
	const activeElement = document.querySelector('[data-context="active"]');
	const submenu = document.querySelector('.submenu_container__ul');
	const overlayRight = document.getElementById('div-overlay-right');
	const overlayLeft = document.getElementById('div-overlay-left');

	function checkScrollable() {
		if (submenu.scrollWidth > submenu.clientWidth) {
			overlayRight.style.display = 'flex';
			overlayRight.addEventListener('click', scrollToRight);
		} else {
			overlayRight.style.display = 'none';
		}

		if (submenu.scrollLeft > 0) {
			overlayLeft.style.display = 'flex';
			overlayLeft.addEventListener('click', scrollToLeft);
		} else {
			overlayLeft.style.display = 'none';
		}
	}

	function scrollToRight() {
		submenu.style.scrollBehavior = 'smooth';
		submenu.scrollLeft = submenu.scrollWidth;
	}

	function scrollToLeft() {
		submenu.style.scrollBehavior = 'smooth';
		submenu.scrollLeft = 0;
	}

	function checkScrollEnd() {
		if (submenu.scrollLeft >= submenu.scrollWidth - submenu.clientWidth) {
			overlayRight.style.display = 'none';
		} else {
			overlayRight.style.display = 'flex';
		}
	}

	function scrollToActiveElement() {
		if (activeElement) {
			const activeElementRect = activeElement.getBoundingClientRect();
			const submenuRect = submenu.getBoundingClientRect();

			if (activeElementRect.right > submenuRect.right) {
				submenu.scrollLeft = submenuRect.right;
			} else if (activeElementRect.left < submenuRect.left) {
				submenu.scrollLeft = activeElementRect.left - submenuRect.left;
			}
		}
	}

	submenu.addEventListener('scroll', function () {
		checkScrollable();
		checkScrollEnd();
	});

	scrollToActiveElement();
	checkScrollable();
});
